module.exports = __webpack_public_path__ + "static/identify-users-cb31e059b5d4dbb14d78d1f2aedfa806.png";